import React from 'react'
import Header from '../Components/Header'
import AboutUs from '../Components/AboutUs'
import Footer from '../Components/Footer'

const About = () => {
  return (
    <>
    <Header/>
    <AboutUs/>
    <Footer/>
    </>
  )
}

export default About
